/**
 * The borne tablet's device token: a separate key from the station's
 * (`~/lib/station/device-token`), so one browser can never hold a borne token
 * where the desk expects a gate token, or the reverse. Same storage rules:
 * localStorage can throw in privacy modes, and a tablet that cannot store a
 * credential is honestly unpaired.
 */
const TOKEN_KEY = "gately_borne_device_token";

export function getBorneDeviceToken(): string | null {
  try {
    return globalThis.localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setBorneDeviceToken(token: string): void {
  try {
    globalThis.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    // See the module docblock.
  }
}

export function clearBorneDeviceToken(): void {
  try {
    globalThis.localStorage.removeItem(TOKEN_KEY);
  } catch {
    // See the module docblock.
  }
}
